import React from "react";
import { Toolbar } from "@dynata/rex-raptor";

export type CustomMenuProp = {
  title?: string;
  subtitle?: string;
  menuItems: Array<{ title: string; onClick: () => void }>;
};

const CustomMenu: React.FC<CustomMenuProp> = ({
  title,
  subtitle,
  menuItems,
}) => {
  return (
    <Toolbar
      title={title ?? ""}
      subTitle={subtitle ?? ""}
      menuItems={menuItems}
    />
  );
};

export default CustomMenu;
